import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '@/config.js';
import ApiService from './services/api.service';

Vue.use(VueI18n);

export function loadLanguageAsync(lang) {
  return ApiService.get(`${config.translationsUrl}${lang}.json`).then((response) => {
    i18n.setLocaleMessage(lang, response.data);
    i18n.locale = lang;
    i18n.silentTranslationWarn = process.env.NODE_ENV !== 'production';
    return response.data;
  });
}

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  EUR: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol'
    }
  }
};

const i18n = new VueI18n({
  messages: {}, // set locale messages
  silentTranslationWarn: true,
  numberFormats
});

export default i18n;
